import { Expose } from 'class-transformer'

export class BookPromotionSalesType {
  @Expose() name: number

  @Expose() startPublishedAt: string

  @Expose() endPublishedAt: string
}
